import {defineStore} from 'pinia'
import {useNuxtApp} from "#app";
import {getSignalRConnection, invoke, off, on, stopSignalRConnection} from '~/services/signalRService'
import type {Notification} from "~~/api/models";
import {HubConnectionState} from '@microsoft/signalr/src/HubConnection';

export interface SocketEventMap {
  ReceiveToast: [
    notification: Notification
  ];
  ReceivePopup: [
    notification: Notification
  ];
  HasUnreadNotifications: [hasUnread: boolean];
  ReceiveUserDeactivated: [];
  ReceiveUserSessionInvalidated: [reasonTitle: string, reasonMessage: string];
}

export const useSocketConnectionStore = defineStore('socketConnection', {
  state: () => ({
    listeners: {} as Record<string, (...args: unknown[]) => void>
  }),
  actions: {
    on<K extends keyof SocketEventMap>(methodName: K, callback: (...args: SocketEventMap[K]) => void) {
      if (!this.listeners[methodName]) {
        on(methodName, callback as (...args: unknown[]) => void);
        this.listeners[methodName] = callback as (...args: unknown[]) => void;
      }
    },

    off(methodName: string) {
      const callback = this.listeners[methodName]
      if (callback) {
        off(methodName, callback)
        delete this.listeners[methodName]
      }
    },
    async invoke(methodName: string, ...args: unknown[]) {
      try {
        return await invoke(methodName, ...args)
      } catch (err) {
        console.error('SignalR Invoke Error: ', err)
        throw err
      }
    },

    async initializeConnection() {
      const {$initializeSignalR} = useNuxtApp()

      if ($initializeSignalR) {
        await $initializeSignalR()
      } else {
        console.error('initializeSignalR function not found')
      }
    },

    async closeConnection() {
      for (const methodName of Object.keys(this.listeners)) this.off(methodName)
      await stopSignalRConnection()
    },

    async connectionIsAlive() {
      const connection = getSignalRConnection()
      if (connection) {
        return connection.state === HubConnectionState.Connected
      }
      return false
    }
  }
})